<div [formGroup]="input_form" class="row">
  <!-- <div class="md:tw-w-1/2">
    <form-field
      #txtStartRange
      type="tel"
      [maxLength]="3"
      [min]="5"
      [max]="100"
      [isOnlyNumber]="true"
      class="tw-w-full"
      [label]="min_label"
      (change)="emit()"
    >
    </form-field>
  </div>

  <div class="md:tw-w-1/2">
    <form-field
      #txtEndRange
      type="tel"
      [maxLength]="3"
      [min]="5"
      [max]="100"
      [isOnlyNumber]="true"
      class="tw-w-full"
      [label]="max_label"
      (change)="emit()"
    >
    </form-field>
  </div> -->

  <!-- txtStartRange -->
  <div class="md:tw-w-1/2">
    <form-field
      type="tel"
      [maxLength]="3"
      [min]="5"
      [control]="input_form?.get(input_startRangeControlName)"
      [value]="txtStartRange"
      (valueChange)="txtStartRange = $event"
      (input)="onChangeMinMaxPrice()"
      [label]="min_label"
      [max]="+txtEndRange"
    >
    </form-field>
  </div>

  <!-- txtEndRange -->
  <div class="md:tw-w-1/2">
    <form-field
      type="tel"
      [maxLength]="3"
      [max]="100"
      [control]="input_form?.get(input_endRangeControlName)"
      [value]="txtEndRange"
      (valueChange)="txtEndRange = $event"
      (input)="onChangeMinMaxPrice()"
      [label]="max_label"
      [min]="+txtStartRange"
    >
    </form-field>
  </div>
</div>
